module.exports = __webpack_public_path__ + "img/34.058a5622.jpg";